"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const auth_mapping_1 = require("./auth.mapping");
const chain_mapping_1 = require("./chain.mapping");
const facility_mapping_1 = require("./facility.mapping");
const import_mapping_1 = require("./import.mapping");
const receipt_mapping_1 = require("./receipt.mapping");
const user_mapping_1 = require("./user.mapping");
const resident_mapping_1 = require("./resident.mapping");
const statistics_mapping_1 = require("./statistics.mapping");
const statement_mapping_1 = require("./statement.mapping");
const comments_mapping_1 = require("./comments.mapping");
const mail_mapping_1 = require("./mail.mapping");
const utils_mapping_1 = require("./utils.mapping");
const activity_mapping_1 = require("./activity.mapping");
const permissions_mapping_1 = require("./permissions.mapping");
const template_mapping_1 = require("./template.mapping");
const collection_flow_mapping_1 = require("./collection-flow.mapping");
const transactions_mapping_1 = require("./transactions.mapping");
const payments_mapping_1 = require("./payments.mapping");
exports.default = {
    payments: payments_mapping_1.PAYMENTS_MAPPING,
    collectionFlow: collection_flow_mapping_1.COLLECTION_FLOW_MAPPING,
    template: template_mapping_1.TEMPLATE_MAPPING,
    permissions: permissions_mapping_1.PERMISSIONS_MAPPING,
    activity: activity_mapping_1.ACTIVITY_MAPPING,
    utils: utils_mapping_1.UTILS_MAPPING,
    receipt: receipt_mapping_1.RECEIPT_MAPPING,
    mail: mail_mapping_1.MAIL_MAPPING,
    comments: comments_mapping_1.COMMENTS_MAPPING,
    statistics: statistics_mapping_1.STATISTICS_MAPPING,
    auth: auth_mapping_1.AUTH_MAPPING,
    chain: chain_mapping_1.CHAIN_MAPPING,
    facility: facility_mapping_1.FACILITY_MAPPING,
    import: import_mapping_1.IMPORT_MAPPING,
    user: user_mapping_1.USER_MAPPING,
    resident: resident_mapping_1.RESIDENT_MAPPING,
    statement: statement_mapping_1.STATEMENT_MAPPING,
    transactions: transactions_mapping_1.TRANSACTIONS_MAPPING
};
